jQuery(document).ready(function($) {
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $("body").addClass("mac");
    } else {
        $("body").addClass("windows");
    }
});

jQuery(window).scroll(function() {   
	    if (jQuery(window).scrollTop() >=1) { 
          
           jQuery(".header-logo-wrapper").addClass("sticky-header-fix");
          
// 	    if(jQuery('.sticky_pages').hasClass( "sticky-header-fix" ))
// 	  	{
// 	  		//jQuery('#header').removeClass("fixed-theme");
// 	  	}
// 	  	else
// 	  	{
// 	  		jQuery('.sticky_pages').addClass("sticky-header-fix");
// 	  	}
	    }
		else{
			jQuery('.sticky_pages').removeClass("sticky-header-fix");
		} 
	 });


// jQuery(window).scroll(function() {    
//     var scroll = jQuery(window).scrollTop();

//     if (scroll >= 700) {
//         jQuery(".header-logo-wrapper").addClass("darkHeader");
//     } else {
//         jQuery(".header-logo-wrapper").removeClass("darkHeader");
//     }
// });


jQuery(function($) {

    var $nav = $('#site-header');
    var $win = $(window);
    var winH = $win.height();   // Get the window height.
    $win.on("scroll", function () {
        if ($(this).scrollTop() > winH ) {
            $nav.addClass("doch");          
        } else {
          
          	$nav.removeClass("doch");
         
        }
    }).on("resize", function(){ // If the user resizes the window
       winH = $(this).height(); // you'll need the new height value
    });

});


jQuery(function($) {

    var $nav = $('#mobi-header');
    var $win = $(window);
    var winH = $win.height();   // Get the window height.
    $win.on("scroll", function () {
        if ($(this).scrollTop() > winH ) {
            $nav.addClass("mobi-head");          
        } else {
          
          	$nav.removeClass("mobi-head");
         
        }
    }).on("resize", function(){ // If the user resizes the window
       winH = $(this).height(); // you'll need the new height value
    });

});

jQuery(document).ready(function() {

            jQuery(".dropdown img.flag").addClass("flagvisibility");

            jQuery(".dropdown dt a").click(function() {
                jQuery(".dropdown dd ul").toggle();
            });
                        
            jQuery(".dropdown dd ul li a").click(function() {
                var text = jQuery(this).html();
                jQuery(".dropdown dt a span").html(text);
                jQuery(".dropdown dd ul").hide();
                jQuery("#result").html("Selected value is: " + getSelectedValue("sample"));
            });
                        
            function getSelectedValue(id) {
                return jQuery("#" + id).find("dt a span.value").html();
            }

            jQuery(document).bind('click', function(e) {
                var $clicked = jQuery(e.target);
                if (! $clicked.parents().hasClass("dropdown"))
                    jQuery(".dropdown dd ul").hide();
            });


            jQuery("#flagSwitcher").click(function() {
                jQuery(".dropdown img.flag").toggleClass("flagvisibility");
            });

});  




// jQuery(window).scroll(function() {   
// 	    if (jQuery(window).scrollTop() >=600) { 
// 	    if(jQuery('#site-header').hasClass( "sticky-header-open" ))
// 	  	{
// 	  		//jQuery('#header').removeClass("fixed-theme");
// 	  	}
// 	  	else
// 	  	{
// 	  		jQuery('#site-header').addClass("sticky-header-open");
// 	  	}
// 	    }
// 		else{
// 			jQuery('#site-header').removeClass("sticky-header-open");
// 		} 
// 	 });




// jQuery(window).scroll(function() {    
//     var scroll = jQuery(window).scrollTop();

//     if (scroll >= 650) {
//         jQuery(".header-logo-wrapper").addClass("darkHeader");
//     } else {
//         jQuery(".header-logo-wrapper").removeClass("darkHeader");
//     }
// });


 jQuery(document).ready(function() {
     jQuery(".mobile-menu-brand").click(function() {
       jQuery(".mobile-menu-brand").toggleClass("active");
       jQuery("#mobile-nav-brand").slideToggle();
       return false;
     });
     jQuery(".mobile-menu-accounts").click(function() {
       jQuery(".mobile-menu-accounts").toggleClass("active");
       jQuery("#mobile-nav-accounts").slideToggle();
       return false;
     });
});


